module.exports = __webpack_public_path__ + "officialStatic/img/solutionActive3.6bb7acc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wireless/solutionActive3.png
// module id = kThf
// module chunks = 0